/**
 * CẤU HÌNH HIỂN THỊ TRẮC NGHIỆM THỰC CHIẾN (chủ đề, xếp loại, định dạng thời gian)
 * Ngân hàng 240 câu hỏi, đáp án, việc bốc đề và chấm điểm đã chuyển sang backend
 * (back-end/src/data/pharmacy-quiz-questions.data.js, services/pharmacy-quiz.service.js) ngày 29/09/2026
 * để đáp án không nằm trong mã giao diện (HT-06 S-12). Giao diện gọi POST /pharmacy-tool/quiz/start và /quiz/submit.
 */

export const QUIZ_CONFIG = {
  totalQuestionsPerTest: 15,
  difficultyDistribution: {
    'Dễ': 5,
    'TB': 6,
    'Khó': 4,
  },
  timeLimitMinutes: 15,
  timeLimitSeconds: 15 * 60,
  maxPointsPerQuestion: 100 / 15, // ~6.6667
  rankingTiers: [
    {
      minScore: 85,
      maxScore: 100,
      rank: 'XUẤT SẮC',
      badge: '🏆',
      color: '#059669', // Emerald
      bgColor: '#ecfdf5',
      borderColor: '#a7f3d0',
      title: 'Năng Lực Xuất Sắc — Đạt Chuẩn Dẫn Dắt',
      assessment: 'Nắm chắc kiến thức nền tảng và vận dụng cực tốt vào các tình huống quầy phức tạp. Đủ năng lực kèm cặp và hướng dẫn lại nhân viên khác.',
      recommendation: 'Tham gia các module nâng cao về Quản trị chiến lược, Đàm phán nhà cung cấp và Tối ưu chuỗi điểm bán.',
      actionCourse: 'Khóa học Quản Trị Chiến Lược & Nhân Sự Cao Cấp'
    },
    {
      minScore: 70,
      maxScore: 84.9,
      rank: 'KHÁ',
      badge: '🎖️',
      color: '#0284c7', // Sky blue
      bgColor: '#f0f9ff',
      borderColor: '#bae6fd',
      title: 'Nền Tảng Tốt — Cần Hoàn Thiện Tình Huống Khó',
      assessment: 'Nền tảng nghiệp vụ vững vàng, xử lý trôi chảy đa số ca bán lẻ thường gặp; còn đôi chút lúng túng ở một vài tình huống khó và phản đối hóc búa.',
      recommendation: 'Tập trung ôn luyện lại các câu tình huống khó đã chọn sai, rà soát lại nguyên tắc 3 lớp để tránh các bẫy tâm lý quen tay.',
      actionCourse: 'Khóa học Xử Lý Từ Chối & Tư Vấn Cắt Liều Chuyên Sâu'
    },
    {
      minScore: 50,
      maxScore: 69.9,
      rank: 'TRUNG BÌNH',
      badge: '📋',
      color: '#d97706', // Amber
      bgColor: '#fffbeb',
      borderColor: '#fde68a',
      title: 'Đạt Chuẩn Cơ Bản — Cần Rèn Thêm Thực Chiến',
      assessment: 'Làm được các việc cơ bản tại quầy nhưng chưa thật sự vững vàng khi gặp khách khó tính, ca bệnh phức tạp hoặc đòi hỏi kỹ năng phối hợp.',
      recommendation: 'Cần học lại các module cơ bản có hệ thống, bám sát các bảng kiểm SOP thao tác chuẩn tại quầy để không làm theo cảm tính.',
      actionCourse: 'Khóa học Chuẩn Hóa Kỹ Năng Đứng Quầy & SOP Thực Chiến'
    },
    {
      minScore: 0,
      maxScore: 49.9,
      rank: 'CẦN HỌC THÊM',
      badge: '⚠️',
      color: '#dc2626', // Red
      bgColor: '#fef2f2',
      borderColor: '#fecaca',
      title: 'Cần Học Lại Từ Đầu — Nguy Cơ Rủi Ro Cao',
      assessment: 'Còn thiếu nhiều kiến thức nền tảng quan trọng, dễ mắc lỗi thao tác và rủi ro pháp lý/an toàn khi đứng quầy độc lập một mình.',
      recommendation: 'Cần được dược sĩ có kinh nghiệm kèm cặp trực tiếp tại quầy và tham gia đào tạo lại bài bản từ các bài học cơ sở.',
      actionCourse: 'Chương Trình Đào Tạo Dược Sĩ Mới Đứng Quầy 30 Ngày'
    }
  ]
};

export const QUIZ_TOPICS = [
  {
    "key": "sale",
    "sheetName": "03_Sale",
    "title": "Kỹ Năng Bán Hàng & Chăm Sóc Khách Hàng",
    "shortTitle": "Bán Hàng & Chăm Sóc Khách",
    "tagLabel": "SALE",
    "icon": "CustomerServiceOutlined",
    "color": "#0284c7",
    "tagColor": "blue",
    "description": "Kỹ năng đón tiếp, khai thác nhu cầu thực, tư vấn giá trị, xử lý từ chối giá đắt, chốt sale tế nhị và chăm sóc giữ chân khách quay lại quầy.",
    "subTopics": [
      "Tiếp đón & khai thác nhu cầu",
      "Tư vấn & trình bày giá trị",
      "Xử lý từ chối",
      "Chốt sale",
      "Upsell & bán kèm",
      "Giữ chân khách & chăm sóc sau bán"
    ]
  },
  {
    "key": "van-hanh",
    "sheetName": "04_Van hanh",
    "title": "Vận Hành Nhà Thuốc Cơ Bản",
    "shortTitle": "Vận Hành Nhà Thuốc",
    "tagLabel": "VẬN HÀNH",
    "icon": "ApartmentOutlined",
    "color": "#059669",
    "tagColor": "green",
    "description": "Nguyên tắc quản lý kho, kiểm soát hạn dùng, nhập hàng & đối soát công nợ, hồ sơ chuẩn GPP, quy trình thao tác chuẩn (SOP), tuyển dụng & tạo động lực nhân sự.",
    "subTopics": [
      "Quản lý kho & tồn kho",
      "Quy trình nhập hàng & công nợ",
      "Chuẩn GPP & hồ sơ pháp lý",
      "Quy trình bán hàng & SOP tại quầy",
      "Tuyển dụng & đào tạo nhân sự",
      "Lương thưởng & giữ người"
    ]
  },
  {
    "key": "marketing",
    "sheetName": "05_Marketing",
    "title": "Kỹ Năng & Kiến Thức Marketing Điểm Bán",
    "shortTitle": "Marketing Điểm Bán",
    "tagLabel": "MARKETING",
    "icon": "ShopOutlined",
    "color": "#7c3aed",
    "tagColor": "purple",
    "description": "Trưng bày quầy kệ chuẩn thương mại (Trade Marketing), nhận diện biển hiệu, thiết kế combo & chương trình ưu đãi, hút khách tại chỗ và qua kênh số.",
    "subTopics": [
      "Trade marketing & trưng bày",
      "Biển hiệu & nhận diện điểm bán",
      "Chương trình khuyến mãi & combo",
      "Xây kênh online",
      "Thu hút & giữ khách hàng",
      "Đo lường & phân tích"
    ]
  },
  {
    "key": "duoc",
    "sheetName": "06_Duoc",
    "title": "Chuyên Môn Dược Thực Chiến Tại Quầy",
    "shortTitle": "Chuyên Môn Dược Thực Chiến",
    "tagLabel": "DƯỢC",
    "icon": "MedicineBoxOutlined",
    "color": "#dc2626",
    "tagColor": "red",
    "description": "Phân loại Rx/OTC an toàn, khai thác tiền sử dùng thuốc, nhận diện cờ đỏ chuyển viện khẩn cấp, tương tác thuốc nguy hiểm & tư vấn đối tượng nhạy cảm.",
    "subTopics": [
      "Phân loại thuốc & nguyên tắc bán",
      "Khai thác thông tin trước khi bán",
      "Dấu hiệu cảnh báo phải chuyển bác sĩ",
      "Tương tác & tương kỵ thường gặp tại quầy",
      "Đối tượng đặc biệt",
      "Bảo quản, hướng dẫn dùng & xử lý sự cố"
    ]
  }
];

/**
 * Lấy thông tin xếp loại theo điểm
 */
export function getRankInfo(score) {
  const tiers = QUIZ_CONFIG.rankingTiers;
  for (const t of tiers) {
    if (score >= t.minScore && score <= t.maxScore) {
      return t;
    }
  }
  return tiers[tiers.length - 1];
}

/**
 * Định dạng thời gian mm:ss
 */
export function formatQuizTime(seconds) {
  if (typeof seconds !== 'number' || isNaN(seconds) || seconds < 0) return '00:00';
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m < 10 ? '0' : ''}${m}:${s < 10 ? '0' : ''}${s}`;
}
